// -----
// We keep all snippet attributes declared here so we can easily track all of them
// -----

// Rich <details>
export const richDetailsAttr = 'data-rd';
export const richDetailsSingletonAttr = 'data-rd-sngl';
export const richDetailsDesktopTriggersOnHoverAttr = 'data-rd-dsktp-hvr';

// Track clicked
export const trackClickedAttr = 'data-tc';
